import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { LoadingComponent } from 'app/components/loading/loading.component';
import { Fazenda, Fazendas } from 'app/interfaces/Fazenda';
import { SelectPadraoComponent } from 'app/components/compartilhados/select-padrao/select-padrao.component';
import { PadraoSelect } from 'app/interfaces/compartilhados/Inputs';
import { MapearDadosService } from 'app/services/mapear-dados/mapear-dados.service';
import { Talhoes } from 'app/interfaces/Talhao';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-encontrar-talhoes',
  standalone: true,
  imports: [CommonModule, LoadingComponent, SelectPadraoComponent, TranslocoModule],
  templateUrl: './encontrar-talhoes.component.html',
  styleUrl: './encontrar-talhoes.component.css'
})

export class EncontrarTalhoesComponent {
  @Input() fazendas!: Fazendas;
  @Input({required:true}) loading: boolean = false;
  @Output() talhaoSelecionado = new EventEmitter<any>();

  public talhoesFiltrados: Talhoes | undefined;
  public fazendaSelecionada: Fazenda | null = null;
  public dadosSelect: PadraoSelect[] = [];
  public talhaoSelecionadoIndex = -1;

  constructor(
    private mapearDadosService: MapearDadosService,
    private translocoService: TranslocoService
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['fazendas']) {
      this.dadosSelect = this.mapearDadosService.mapearDadosArray<Fazenda, PadraoSelect>(this.fazendas, { vc_nome: 'label', sr_id: 'id' }, false);
      this.filtrarFazendas(null);
    }
  }

  public atualizarTalhaoSelecionado(talhao: any, index: number): void {
    this.talhaoSelecionadoIndex = index;
    this.talhaoSelecionado.emit(talhao);
  }

  public filtrarTalhoes(event: Event): void {
    const input = event.target as HTMLInputElement;
    const valor = input.value;

    this.talhoesFiltrados = this.fazendaSelecionada?.talhoes?.filter(t => t.vc_nome.includes(valor));
  }

  public aplicarFiltroFazenda(id: string | null): void {
    this.filtrarFazendas(id);
  }

  public filtrarFazendas(id: string | null): void {
    this.fazendaSelecionada = this.fazendas?.find(f => f.sr_id?.toString() === id) ?? null;
    this.talhoesFiltrados = this.fazendaSelecionada?.talhoes;
    this.talhaoSelecionadoIndex = -1;
  }
}
